import { lazy, Suspense } from "react";
import Hero from "@/components/sections/hero";
import ManifestoFlow from "@/components/manifesto-flow";
import ScrollProgress from "@/components/scroll-progress";
import SmoothScroll from "@/components/smooth-scroll";
import { ThemeProvider } from "@/components/theme-provider";
import { LanguageProvider } from "@/context/language-context";
import { Preloader } from "@/components/preloader";
import Navbar from "@/components/navbar";

const About = lazy(() => import("@/components/sections/about"));
const Stack = lazy(() => import("@/components/sections/stack"));
const Roadmap = lazy(() => import("@/components/sections/roadmap"));
const Projects = lazy(() => import("@/components/sections/projects"));
const Contact = lazy(() => import("@/components/sections/contact"));

function SectionFallback({ minHeight = "40vh" }: { minHeight?: string }) {
  return <div aria-hidden className="w-full" style={{ minHeight }} />;
}

export default function App() {
  return (
    <LanguageProvider>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
        themes={["light", "dark", "system"]}
      >
        <Preloader />
        <SmoothScroll>
          <Navbar />
          <ScrollProgress />
          <main className="relative bg-background">
            <Hero />
            <div className="relative z-10 border-t border-border bg-background">
              <section id="about">
                <Suspense fallback={<SectionFallback minHeight="80vh" />}>
                  <About />
                </Suspense>
              </section>
              <ManifestoFlow />
              <section id="stack">
                <Suspense fallback={<SectionFallback minHeight="60vh" />}>
                  <Stack />
                </Suspense>
              </section>
              <ManifestoFlow reverse />
              <section id="roadmap">
                <Suspense fallback={<SectionFallback minHeight="80vh" />}>
                  <Roadmap />
                </Suspense>
              </section>
              <ManifestoFlow />
              <section id="projects">
                <Suspense fallback={<SectionFallback minHeight="100vh" />}>
                  <Projects />
                </Suspense>
              </section>
              <ManifestoFlow reverse />
              <section id="contact">
                <Suspense fallback={<SectionFallback minHeight="60vh" />}>
                  <Contact />
                </Suspense>
              </section>
            </div>
          </main>
        </SmoothScroll>
      </ThemeProvider>
    </LanguageProvider>
  );
}
